import * as React from 'react';
import { doctorListHeader, UserSelectBody, Type } from './UserListField';
import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import '../css/modal_layout.css';
import * as Header from '../constants/Header';
import { Dialog, Button, Form, Input } from 'element-react';
import { Hospital } from '@src/interfaces';

interface DoctorListProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;
}

interface ListState {
  showAddDialog: boolean;
  form: Hospital;
}

class DoctorList extends React.Component<DoctorListProps, ListState> {

  constructor (props: any) {
    super(props);
    this.state = {
      showAddDialog: false,
      form: {
        name: ''
      }
    };
  }

  componentWillMount() {
    document.title = '医師一覧画面';

    this.props.headerActions.setPage(Header.DOCTOR_LIST);

    // Action
    this.props.moffAPIActions.getAllDoctors();
  }

  onChange(key: string, value: any) {
    this.state.form[key] = value;
    this.forceUpdate();
  }

  onSubmit() {
    console.log(this.state.form);
  }

  handleFieldClicked = (userId: string) => {
    // 居宅訪問 pr 興味関心チェック.
    // if (this.props.type === Type.HomeVisit || this.props.type === Type.InterestCheck) {
    //   // 親HomeVisitコンポーネントの処理.
    //   this.context.callbackParent(userId);
    //   return;
    // }

    // 詳細画面への導線.
    // window.location.href = `${this.urlBase}/${userId}`;
  }

  render () {
    return (
      <div>
        <Dialog
          title="医師追加"
          size="tiny"
          visible={this.state.showAddDialog}
          onCancel={() => this.setState({ showAddDialog: false })}
          lockScroll={false}
        >
          <Dialog.Body>
            <Form model={this.state.form} labelWidth="120">
              <Form.Item label="医療機関名">
                <Input value={this.state.form.name} onChange={this.onChange.bind(this, 'name')} />
              </Form.Item>
            </Form>
          </Dialog.Body>
          <Dialog.Footer className="dialog-footer">
            <Button onClick={() => this.setState({ showAddDialog: false })}>キャンセル</Button>
            <Button type="primary" onClick={() => this.onSubmit()}>医療機関登録</Button>
          </Dialog.Footer>
        </Dialog>
        <div className="btnStyle02">
          <Button onClick={() => this.setState({ showAddDialog: true })}>医師登録</Button>
        </div>
        <div id="userlist">
          <table className="tblStyle01">
            <thead>
              <tr>
                {doctorListHeader}
              </tr>
            </thead>
            <tbody>
              <UserSelectBody
                type={Type.Doctor}
                doctors={this.props.moffAPI.doctors}
                checkedUserIds={[]}
                moffAPI={this.props.moffAPI}
                moffAPIActions={this.props.moffAPIActions} 
                download={false}
              />
            </tbody>
          </table>
        </div>
        <style type="text/css">
          {'#wrapper .contentIn { padding-top: 50px; }'}
          {'.btnStyle02 { margin-bottom: 16px; }'}
        </style>
      </div>
    );
  }
}

export default DoctorList;



// WEBPACK FOOTER //
// ./src/components/DoctorList.tsx